var AggConstants;
(function (AggConstants) {
    AggConstants["SUM"] = "SUM";
    AggConstants["COUNT"] = "COUNT";
    AggConstants["DISTINCT_COUNT"] = "DISTINCT_COUNT";
})(AggConstants || (AggConstants = {}));
export default AggConstants;
